export enum QuestionFactorType {
  impact = 'IMPACT',
  probability = 'PROBABILITY',
  both = 'BOTH'
}
